import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import LoginLogo from 'assets/images/login-logo.svg';
import SubscribiliLogo from 'assets/images/logo-subscribili.png';
import React from 'react';
import Theme from 'theme';

// Testimonial carousel nav arrows — exported from Figma. Both directions use
// the enabled (brand orange #BA7D49) arrow since the carousel loops infinitely.
const testimonialArrow = (dir) =>
  React.createElement('img', {
    className: 'testimonial-arrow-icon',
    src: `/images/home-images/testimonial-arrow-${dir}-enabled.svg`,
    alt: dir === 'right' ? 'Next review' : 'Previous review',
  });

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Prostho Endo Dental',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'prosthoendodentalSubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  heroLocaleColor: 'secondary',
  splitPlans: true,
  enablePlanCardConfig: true,
  headerProps: {
    enable: true,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      alignContent: 'center',
      alignText: 'center',
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
        variant: 'outlined',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img-mobile.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignTitle: 'center',
      alignCard: 'center',
      ctaButton: {
        enable: true,
        align: 'center',
        scrollTo: 'pricing-benefit-section',
        variant: 'contained',
        color: 'primary',
        size: 'large',
      },
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit: 4,
      cardVariant: 5,
      regularCardVariant: 1,
      hybridPlanCardConfig: true,
      regularPlanCount: 3,
      tabVariant: 1,
      disableGroupSavings: true,
      maxPlansPerSlide: 6,
      plansPerRow: { xs: 1, sm: 1, md: 1, lg: 3 },
      carouselResponsiveItems: {
        superLargeDesktop: 3,
        desktop: 3,
        tablet: 1,
        mobile: 1,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        usePrimaryPillForAll: true,
        buttonProps: {
          customSpace: 11,
          normalVariant: 'outlined',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
      },
      offerBand: {
        enable: true,
        variant: 1,
        linkTo: '/savings-summary',
        primaryButtonProps: {
          color: 'secondary',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: true,
      variant: 1,
      alignTitle: 'left',
      messageType: 'body1',
      showDots: true,
      showArrows: true,
      heroImage: '/images/home-images/testimonial.png',
      gridSpacing: { xSmall: 12, medium: 6 },
      arrowProps: {
        icons: {
          left: testimonialArrow('left'),
          right: testimonialArrow('right'),
        },
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      alignTitle: 'left',
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    // Show "Login" + "Not now" (instead of Book Appointment).
    enableBookAppointment: false,
    // "Not now" styled like the hero Login button — outlined brand teal.
    secondaryButtonProps: {
      variant: 'outlined',
      color: 'primary',
    },
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
    subscribiliLogo: SubscribiliLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
